var $ = require('jquery');

var CardFaults = require('../_modules/molecules/card-fault/card-fault');
CardFaults.init();

var DynamicsModal = require('../_modules/organisms/dynamics-modal/dynamics-modal');
DynamicsModal();

var KnowledgeBaseModal = require('../_modules/organisms/knowledge-base-modal/knowledge-base-modal');
KnowledgeBaseModal();

var Dynamic = require('../_modules/molecules/dynamic/dynamic');
Dynamic();

var Debug = require('../_modules/organisms/debug/debug');
Debug();

var Alert = require('../_modules/molecules/alert/alert');
Alert();

require('siriwavejs');
$(window).load(function () {
    if ($('.wave-loader').length) {
        var SW = new SiriWave({
            container: $('.wave-loader__canvas')[0],
            height: 200,
            cover: true,
            autostart: true,
            color: '#25747C',
            speed: 0.05
        });
    }
});
